/**
 * 404 Not Found Page
 */

import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
  const { t } = useTranslation('errors');

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gradient-to-br from-gray-950 via-gray-900 to-gray-950">
      {/* Animated background gradient orbs */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 -left-4 w-96 h-96 bg-waffle-orange/20 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob"></div>
        <div className="absolute top-0 -right-4 w-96 h-96 bg-amber-500/20 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-blob animation-delay-2000"></div>
      </div>

      <div className="relative text-center max-w-md w-full">
        <div className="rounded-3xl p-6 sm:p-8 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl border border-white/20 shadow-2xl">
          {/* Logo */}
          <img
            src="/logo.svg"
            alt="Family Waffle"
            className="w-20 h-20 mx-auto mb-6"
          />

          {/* 404 Text */}
          <h1 className="text-6xl font-bold bg-gradient-to-r from-waffle-orange to-amber-500 bg-clip-text text-transparent mb-2">
            {t('notFound.title')}
          </h1>

          <h2 className="text-xl sm:text-2xl font-semibold text-white mb-4">
            {t('notFound.heading')}
          </h2>

          <p className="text-sm sm:text-base text-gray-300 mb-8">
            {t('notFound.description')}
          </p>

          <a
            href="/"
            className="inline-block px-6 py-3 bg-gradient-to-r from-waffle-orange to-amber-500 text-white font-semibold rounded-lg hover:shadow-lg hover:shadow-waffle-orange/25 transition-all min-h-[44px]"
          >
            {t('notFound.goHome')}
          </a>
        </div>
      </div>
    </div>
  );
}
